import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, NgForm, Validators} from "@angular/forms";
import {ForwardingNgFormRef, LocalFormGroupValidationErrors} from "../../../../lib/util/services";
import {Angular2Multiselects} from "../../../../util/multiselect";
import {MultiselectOptionItem, UiConstants} from "../../../../util/core-utils";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {InvoiceSpending} from "../../../../lib/invoice/spending/invoice-spending.service";
import {CustomerRecordService} from "../../../../lib/customer/customer-record.service";
import {UserGroupMultiselectProvider} from "../../../../lib/user-group/user-group-multiselect.provider";
import {RegistrationSettingsService} from "../../../../lib/registration/settings/registration-settings.service";
import {ConfigurationResource} from "../../../../lib/configuration/configuration.service";
import {Set} from "immutable";
import RegistrationType = ConfigurationResource.RegistrationType;

@Component({
  selector: 'app-customer-record-helpdesk-invite-dialog',
  templateUrl: './customer-record-helpdesk-invite-dialog.component.html',
  styleUrls: ['./customer-record-helpdesk-invite-dialog.component.scss']
})
export class CustomerRecordHelpdeskInviteDialogComponent implements OnInit {

  UiConstants = UiConstants;

  model: HelpdeskInviteModel = new HelpdeskInviteModel();

  @ViewChild('f', {static: true})
  form: NgForm;
  formGroup: FormGroup;
  private formGroupValidationErrors: LocalFormGroupValidationErrors;
  searchableDropdownSettings: Angular2Multiselects.Settings;
  userGroups: MultiselectOptionItem<number>[] = [];
  userGroupIds: Set<number> = Set.of();

  contactInviteResult: {
    invited: string,
    alreadyRegistered: string,
    invalidEmail: string
  } | null = null;


  constructor(public dialogRef: MatDialogRef<CustomerRecordHelpdeskInviteDialogComponent>,
              private fb: FormBuilder,
              private customerRecordService: CustomerRecordService,
              private userGroupMultiselectProvider: UserGroupMultiselectProvider,
              private registrationSettingsService: RegistrationSettingsService,
              @Inject(MAT_DIALOG_DATA) public data: CustomerRecordHelpdeskInviteDialogData) {
    this.loadModel();
    this.formGroup = this.createFormGroup(this.fb);
    this.formGroupValidationErrors = LocalFormGroupValidationErrors.ofForm(
      this.createForwardingHtmlForm(),
      this.formGroup
    );
    this.loadRegistrationSettings();
  }

  public static openDialog(
    dialog: MatDialog,
    data: CustomerRecordHelpdeskInviteDialogData,
    resultCallback: (result: CustomerRecordHelpdeskInviteDialogResult) => void) {
    const dialogRef = dialog.open(CustomerRecordHelpdeskInviteDialogComponent, {
      closeOnNavigation: true,
      data: data,
      width: '60%',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe((result: CustomerRecordHelpdeskInviteDialogResult) => {
      resultCallback(result);
    });
  }

  ngOnInit() {
    this.initDropDown();
  }

  initDropDown() {
    this.searchableDropdownSettings = new Angular2Multiselects.SettingsBuilder()
      .singleSelection(true)
      .enableSearchFilter(true)
      .enableCheckAll(false)
      .remoteSearch(true)
      .build();
  }

  closeDialog(modified: boolean) {
    this.dialogRef.close({modified: modified});
  }

  submit() {
    if (this.contactInviteResult) {
      this.closeDialog(this.contactInviteResult.invited.length > 0);
      this.contactInviteResult = null;
      return;
    }
    if (this.hasLocalFieldError()) {
      return;
    } else {
      this.inviteToHelpdesk();
    }
  }

  hasFieldError(field: InvoiceSpending.ValidatedField): boolean {
    return false;
  }

  removeFieldError(field: InvoiceSpending.ValidatedField) {
  }

  getFieldErrorText(field: InvoiceSpending.ValidatedField): string {
    return '';
  }

  private createForwardingHtmlForm() {
    return new ForwardingNgFormRef({
      formFn: () => {
        return this.form;
      }
    });
  }

  private createFormGroup(fb: FormBuilder): FormGroup {
    return fb.group(
      {
        userGroups: fb.control(
          {value: this.model._userGroups},
          [Validators.required]
        )
      }
    );
  }

  hasLocalFieldError(formControlName?: string, errorCode?: string): boolean {
    return this.formGroupValidationErrors.hasFieldError(formControlName, errorCode);
  }

  inviteToHelpdesk() {
    if (this.formGroup.invalid) {
      return;
    }
    this.customerRecordService.inviteToHelpdesk({
      customerRecordIds: this.data.customerRecordIds,
      userGroupIds: this.model.userGroupIds
    }).subscribe(
      (result) => {
        this.contactInviteResult = {
          invited: result.invited.toArray().map(cr => cr.name).join(', '),
          alreadyRegistered: result.alreadyRegistered.toArray().map(cr => cr.name).join(', '),
          invalidEmail: result.invalidEmail.toArray().map(cr => cr.name).join(', ')
        };
      },
      error => {

      });
  }

  onUserGroupSearch(q?: string) {
    this.userGroupMultiselectProvider.loadActiveWithIdSet(this.userGroupIds, q).subscribe(groups => {
      if (!q && groups.length === 1) {
        this.model._userGroups = groups;
      }
      this.userGroups = groups;
    });
  }

  private loadModel() {
  }

  private loadRegistrationSettings() {
    this.registrationSettingsService.get({type: RegistrationType.HELPDESK}).subscribe(settings => {
      if (settings.defaultUserGroupIds) {
        this.userGroupIds = Set.of(...settings.defaultUserGroupIds);
      }
    });
  }
}

class HelpdeskInviteModel {
  _userGroups: MultiselectOptionItem<number>[] = [];

  get userGroupIds(): Set<number> {
    return Set.of(...this._userGroups.map(ug => ug.id));
  }
}

export interface CustomerRecordHelpdeskInviteDialogData {
  customerRecordIds: Set<number>;
}

export interface CustomerRecordHelpdeskInviteDialogResult {
  modified: boolean;
}
